<app-landing-navbar></app-landing-navbar>

<main class="create-password-page">
  <section class="create-password-layout">
    <div class="create-password-art" aria-hidden="true">
      <div class="auth-art-shell">
        <h2 class="auth-art-headline auth-scroll-reveal">
          Simplifies And Automates Vendor Interactions With Government
          Organizations.
        </h2>

        <div class="auth-art-scene auth-scroll-reveal">
          <img
            class="auth-art-image auth-art-image--dashboard auth-animate-float"
            src="assets/svgs/dashboard.svg"
            alt=""
          />
          <img
            class="auth-art-image auth-art-image--bar-chart auth-animate-float-delayed"
            src="assets/svgs/bar-chart.svg"
            alt=""
          />
          <img
            class="auth-art-image auth-art-image--chart auth-animate-float-slow"
            src="assets/svgs/chart.svg"
            alt=""
          />
        </div>

        <p class="auth-art-caption auth-scroll-reveal">
          Everything the vendor lifecycle needs, in one coordinated system.
        </p>
      </div>
    </div>

    <div class="create-password-panel">
      <div class="create-password-card">
        <div class="create-password-brand">
          <div class="create-password-brand__mark">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.4"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="3"></circle>
              <circle cx="12" cy="5" r="1.5" fill="currentColor"></circle>
              <circle cx="12" cy="19" r="1.5" fill="currentColor"></circle>
              <circle cx="5" cy="12" r="1.5" fill="currentColor"></circle>
              <circle cx="19" cy="12" r="1.5" fill="currentColor"></circle>
              <line x1="12" y1="6.5" x2="12" y2="9"></line>
              <line x1="12" y1="15" x2="12" y2="17.5"></line>
              <line x1="6.5" y1="12" x2="9" y2="12"></line>
              <line x1="15" y1="12" x2="17.5" y2="12"></line>
            </svg>
          </div>
          <div class="create-password-brand__text">
            <span class="create-password-brand__title">VMS</span>
            <span class="create-password-brand__caption"
              >Vendor Management System</span
            >
          </div>
        </div>

        <div class="create-password-copy">
          <h1>Create Password</h1>
          <p>
            Choose a secure password to activate your vendor account and finish
            setup.
          </p>
        </div>

        @if (!requestToken) {
          <div class="create-password-alert">
            This password setup link is invalid or has expired. Request a new
            link or return to sign in.
          </div>
        }

        <form
          class="create-password-form"
          [formGroup]="createPasswordForm"
          (ngSubmit)="submit()"
        >
          <label class="create-password-field">
            <span class="create-password-field__label">Password</span>
            <span
              class="create-password-input"
              [class.create-password-input--invalid]="passwordControl.invalid && (passwordControl.touched || passwordControl.dirty)"
            >
              <input
                [type]="showPassword ? 'text' : 'password'"
                formControlName="password"
                placeholder="**************"
                autocomplete="new-password"
                [attr.aria-invalid]="passwordControl.invalid && (passwordControl.touched || passwordControl.dirty)"
                [disabled]="isSubmitting"
              />
              <button
                type="button"
                class="create-password-input__toggle"
                (click)="togglePasswordVisibility()"
                [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
                [disabled]="isSubmitting"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.8"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6-10-6-10-6Z"
                  ></path>
                  <circle cx="12" cy="12" r="2.5"></circle>
                </svg>
              </button>
            </span>
            @if (passwordErrorMessage) {
              <span class="create-password-field__error">{{ passwordErrorMessage }}</span>
            }
          </label>

          <label class="create-password-field">
            <span class="create-password-field__label">Confirm Password</span>
            <span
              class="create-password-input"
              [class.create-password-input--invalid]="confirmPasswordControl.invalid && (confirmPasswordControl.touched || confirmPasswordControl.dirty) || (createPasswordForm.hasError('passwordMismatch') && (confirmPasswordControl.touched || confirmPasswordControl.dirty))"
            >
              <input
                [type]="showConfirmPassword ? 'text' : 'password'"
                formControlName="confirmPassword"
                placeholder="**************"
                autocomplete="new-password"
                [attr.aria-invalid]="(confirmPasswordControl.invalid && (confirmPasswordControl.touched || confirmPasswordControl.dirty)) || (createPasswordForm.hasError('passwordMismatch') && (confirmPasswordControl.touched || confirmPasswordControl.dirty))"
                [disabled]="isSubmitting"
              />
              <button
                type="button"
                class="create-password-input__toggle"
                (click)="toggleConfirmPasswordVisibility()"
                [attr.aria-label]="showConfirmPassword ? 'Hide confirm password' : 'Show confirm password'"
                [disabled]="isSubmitting"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.8"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6-10-6-10-6Z"
                  ></path>
                  <circle cx="12" cy="12" r="2.5"></circle>
                </svg>
              </button>
            </span>
            @if (confirmPasswordErrorMessage) {
              <span class="create-password-field__error">{{ confirmPasswordErrorMessage }}</span>
            }
          </label>

          <button type="submit" class="create-password-submit" [disabled]="!canSubmit">
            {{ isSubmitting ? 'Saving...' : 'Create Password' }}
          </button>

          <p class="create-password-footer">
            Need a new link?
            <a routerLink="/forgot-password">Request password reset</a>
          </p>
        </form>
      </div>
    </div>
  </section>
</main>
